<div class="create-mcq-view" role="dialog" aria-labelledby="dialog-title" aria-describedby="dialog-description">
    <div class="heading">
        <div id="dialog-title">{{data.update ? 'Update' : 'Add New'}} Multi Choice Question</div>
        <div id="dialog-description" class="sr-only">Form to create or update a multiple choice question with options
            and topics</div>
        <mat-icon aria-hidden="false" aria-label="close icon" class="close-icon" (click)="cancel()" tabindex="0"
            role="button">close</mat-icon>
    </div>
    <form [formGroup]="createMcqFrom" mat-dialog-content>
        <div class="time-limit-level-section">
            <div class="d-level">
                <label class="label-txt">DIFFICULTY LEVEL </label>
                <mat-form-field appearance="outline" class="level-form-field">
                    <mat-label>Levels</mat-label>
                    <mat-select formControlName="difficultyLevel">
                        <mat-option *ngFor="let level of difficultyLevels" [value]="level.id">{{level.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="editor-section">
            <label class="label-txt">Multiple Choice Question</label>
            <angular-editor formControlName="questionText" [config]="editorConfig" id="qconfig"></angular-editor>
        </div>

        <div class="options-section">
            <label class="label-txt">Answer Options</label>
            <div class="option-list">
                <div class="option-item" *ngFor="let option of enterpriseOptions.controls; let i = index"
                    [ngClass]="{'correct-option': i == correctOptionIdx}">
                    <div class="option-header">
                        <div class="option-title">Option {{ i + 1 }}</div>
                        <button mat-icon-button class="delete-option-btn"
                            [disabled]="i === correctOptionIdx || enterpriseOptions.length <= 1"
                            (click)="removeOption(i)" matTooltip="Remove option">
                            <mat-icon>remove_circle_outline</mat-icon>
                        </button>
                    </div>
                    <div class="option-editor">
                        <angular-editor [formControl]="option" [config]="optionEditorConfig"
                            [placeholder]="'Enter option text here...'" [id]="'option-editor-' + i">
                        </angular-editor>
                    </div>
                    <div class="option-footer">
                        <mat-radio-button color="primary" [checked]="correctOptionIdx === i"
                            (change)="setCorrectOption(i)" class="correct-radio">
                            Correct Answer
                        </mat-radio-button>
                    </div>
                </div>
            </div>

            <div class="add-option-section">
                <button mat-stroked-button color="primary" (click)="addOption()" class="add-option-btn">
                    <mat-icon>add_circle_outline</mat-icon>
                    <span>Add Option</span>
                </button>
            </div>
        </div>

        <div class="topics-tags-sec">
            <div class="topic-form-field">
                <label class="label-txt">TOPICS </label>
                <div class="topics">
                    <ng-container infiniteScroll [infiniteScrollDistance]="2"
                        [infiniteScrollContainer]="'.topics .item2'" [infiniteScrollThrottle]="50" [fromRoot]="true"
                        (scrolled)="getNextBatchTopics()">
                        <div class="dropdown-chip-container">
                            <ng-multiselect-dropdown appFocusOnClick [placeholder]="'Select a topic...'"
                                [settings]="topicsSettings" [data]="topics" formControlName="selectedTopics"
                                (onSelect)="onTopicItemSelect($event)" (onDeSelect)="onTopicDeselect($event)"
                                (onFilterChange)="onTopicFilterChange($event)">
                            </ng-multiselect-dropdown>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="topic-form-field">
                <label class="label-txt">Choose Sub Topics (Optional)</label>
                <div class="sub-topics">
                    <ng-container infiniteScroll [infiniteScrollDistance]="2"
                        [infiniteScrollContainer]="'.sub-topics .item2'" [infiniteScrollThrottle]="50" [fromRoot]="true"
                        (scrolled)="getNextBatchSubTopics()">
                        <div class="dropdown-chip-container">
                            <ng-multiselect-dropdown appFocusOnClick [placeholder]="'Search a topic...'"
                                [settings]="subTopicsSettings" [data]="subTopics" formControlName="subTopics"
                                [disabled]="!hasSelectedTopics()" (onFilterChange)="onFilterChange($event)">
                            </ng-multiselect-dropdown>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

    </form>
    <div class="actions">
        <button mat-flat-button [disabled]="!createMcqFrom.valid" color="primary" (click)="addOrUpdateQuestion()">
            {{data.update ? 'Update Question' : 'Add Question'}}
        </button>
    </div>
</div>